module.exports = __webpack_public_path__ + "static/src/nrl-teams/images/broncos.3e38309.png";


//////////////////
// WEBPACK FOOTER
// ./src/nrl-teams/images/broncos.png
// module id = XWnc
// module chunks = 0